import { loginAPI } from "../../apis/LoginAPI.jsx";
import { refdataAPI } from "../../apis/RefdataAPI.jsx";
import { utils } from "../../utils/Utils.jsx";
import Logger from "../../utils/Logger.js";

export default class DashboardService {
  getClientConfig(token, setConfig) {
    loginAPI
      .getClientConfig(token)
      .then((response) => {
        if (response.status === 200 && response.data) {
          setConfig(response.data);
        } else {
          //Failure
          console.log("getClientConfig failure", response);
        }
      })
      .catch((error) => {
        //Failure
        console.log("getClientConfig error", error);
      });
  }

  getCountries(globalProps, setState) {
    refdataAPI
      .getCountries()
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log("getAllCountries success", response);
          let globalPropsAux = globalProps;

          globalPropsAux.countries = utils.orderAlphabetically(
            response.data.filter((country) => country.iso_3166_3),
            "country",
          );
          setState({
            globalProps: globalPropsAux,
          });
        } else {
          console.log("getAllCountries failure", response);
        }
      })
      .catch((error) => {
        //Failure
        console.log("getAllCountries error", error);
      });
  }

  getAreaCodes(token, globalProps, setState) {
    refdataAPI
      .getAllCountries(token)
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log("getAllCountries success", response);
          let globalPropsAux = globalProps;

          globalPropsAux.areaCodes = utils.removeObjectDuplicates(
            response.data
              .filter((country) => country.phone_area_code)
              .sort((a, b) => {
                const phone_area_codeA = a.phone_area_code;
                const phone_area_codeB = b.phone_area_code;
                if (phone_area_codeA < phone_area_codeB) {
                  return -1;
                }
                if (phone_area_codeA > phone_area_codeB) {
                  return 1;
                }
                return 0;
              }),
            "phone_area_code",
          );

          setState({
            globalProps: globalPropsAux,
          });
        } else {
          console.log("getAllCountries failure", response);
        }
      })
      .catch((error) => {
        //Failure
        console.log("getAllCountries error", error);
      });
  }
}
